import React from "react";
import { Calendar, Clock, Flag } from "lucide-react";
import Card from "./Card";
import InfoChip from "./InfoChip";
import StatusBadge from "./StatusBadge";
import { displayValue } from "./utils";
import Txt from "../../../Text";
import textTranslator from "../../../../utils/useTextTranslator";

const Text = ({ children, className, page = "APPOINTMENTS" }) => {
	return (
		<Txt page={page} className={className} keyName={page}>
			{children}
		</Txt>
	);
};

const AppointmentOverviewCard = ({ appointment, formatDate, formatTime, darkMode, arClass }) => {
	const right = (
		<StatusBadge status={appointment?.status} Text={Text} darkMode={darkMode} />
	);

	return (
		<Card
			title={`${textTranslator("Appointment", "APPOINTMENTS")} #${displayValue(appointment?.id)}`}
			subtitle={textTranslator("Appointment details", "APPOINTMENTS")}
			icon={Flag}
			right={right}
			darkMode={darkMode}
			arClass={arClass}
			bodyClassName="pt-3"
		>
			<div className="grid grid-cols-1 items-center gap-4 xl:grid-cols-12">
				<div className="xl:col-span-8">
					<div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
						<InfoChip
							icon={Calendar}
							label="Appointment Date"
							value={appointment?.appointmentDate ? formatDate(appointment.appointmentDate) : "-"}
							darkMode={darkMode}
							variant="tile"
							Text={Text}
						/>
						<InfoChip
							icon={Clock}
							label="Appointment Time"
							value={appointment?.appointmentTime ? formatTime(appointment.appointmentTime) : "-"}
							darkMode={darkMode}
							variant="tile"
							Text={Text}
						/>
						<InfoChip
							icon={Flag}
							label="Status"
							value={textTranslator(appointment?.status, "APPOINTMENTS") || "-"}
							darkMode={darkMode}
							variant="tile"
							Text={Text}
						/>
					</div>
				</div>
			</div>
		</Card>
	);
};

export default AppointmentOverviewCard;
